import Breadcrumb from "./BreadCrumbs";
import ScrollToTop from '../utils/scrollToTop.js';

export default function Infrastructure() {
  return (

    <div>
      <ScrollToTop />

      <section className="relative h-[320px] bg-cover bg-center sm:h-[400px]">
        {/* ✅ Hero Image with Overlay */}
        <div
          className="relative flex h-full w-full items-end justify-start bg-cover bg-center p-6 text-white sm:p-8"
          style={{ backgroundImage: `url('/infra5.JPG')` }}
        >
          {/* Overlay with Smooth Transition */}
          <div className="absolute inset-0 bg-black/40"></div>

          {/* Text on Top of the Overlay */}
          <h1 className="z-10 text-3xl font-bold sm:text-4xl">Infrastructure</h1>
        </div>
      </section>

      {/* ✅ Breadcrumb Just Below the Hero Section */}
      <Breadcrumb />
      <div className="w-full h-[2px] bg-yellow-900"></div>


      {/* Infra Details Section */}
      <section class=" py-12 px-6 bg-white">
        <div class="container mx-auto">
          {/* <!-- Main About Section --> */}
          <div class="flex flex-col md:flex-row items-center md:items-start justify-normal text-left md:text-left">
            {/* <!-- Left Side (Title) --> */}
            <div>
              {/* <h2 class="text-2xl md:text-4xl font-bold text-green-900">Quality Products.</h2>
        <h2 class="text-2xl md:text-4xl font-bold text-green-900">Guranteed.</h2> */}
            </div>
            {/* <!-- Right Side (Description) --> */}
            <div>
              <h1 className="text-green-700 font-serif text-lg font-extrabold">Our Infrastructure</h1>
              <p className=" text-sm font-serif">We take pride in our state-of-the-art processing plant, equipped with the latest John Fowler Westrup technology from Denmark. Our 5-ton-per-hour grading plant  advanced gravity separators, a magnetic system for soil particle removal, and a 9-spiral separator system designed specifically for superior soybean grading.

                To ensure optimal storage conditions, we have built a modern warehouse spanning half an acre, featuring a best-in-class shed with heat-dampening materials to minimize moisture loss and preserve seed quality. Our infrastructure is designed to maintain the highest standards of seed purity, consistency, and longevity.
              </p>
            </div>
          </div>

          {/* <!-- Stats Section --> */}
          <div class="mt-8 text-center">
            <h3 class="text-xl md:text-2xl font-semibold inline-block border-b-2 border-yellow-900 pb-1 text-green-900 ">A Brief about our Infrastructure</h3>
            <div class="mt-4 grid grid-cols-1 md:grid-cols-3 gap-6">
              <div class="p-4 bg-white shadow rounded-lg border-2 border-green-500">
                <h4 class="text-2xl font-bold text-green-900">22000 sq ft</h4>
                <p class="text-gray-600">Storage Capacity</p>
              </div>
              <div class="p-4 bg-white shadow rounded-lg border-2 border-green-500">
                <h4 class="text-2xl font-bold text-green-900">5 Ton/Day</h4>
                <p class="text-gray-600">Grading Plant</p>
              </div>
              <div class="p-4 bg-white shadow rounded-lg border-2 border-green-500">
                <h4 class="text-2xl font-bold text-green-900">9 Spiral Separator System </h4>
                <p class="text-gray-600">Designed specially for superior Soyabean grading </p>
              </div>
              <div class="p-4 bg-white shadow rounded-lg border-2 border-green-500">
                <h4 class="text-2xl font-bold text-green-900">state-of-the-art processing plant </h4>
                <p class="text-gray-600"> equipped with the latest John Fowler Westrup technology from Denmark.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="w-full h-[2px] bg-yellow-900"></div>


      <section className="bg-gradient-to-r from-white to-gray-100 px-4 py-10 sm:px-6 sm:py-14" aria-label="Infrastructure gallery">
        <div className="mx-auto grid max-w-6xl grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {['/infra1.JPG', '/infra5.JPG', '/infra6.JPG', '/infra2.JPG', '/infra3.JPG', '/infra4.JPG'].map((image, index) => (
            <img
              key={image}
              src={image}
              alt={`Vasundhara Seeds infrastructure ${index + 1}`}
              className="h-56 w-full rounded-xl border border-gray-200 object-cover shadow-sm transition duration-300 hover:scale-[1.02] sm:h-64"
              loading="lazy"
            />
          ))}
        </div>
      </section>
      <div className="w-full h-[2px] bg-yellow-900"></div>

    </div>
  )
};
